import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeadset = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 14V12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12V14",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.75,
			y: 12.75,
			width: 4,
			height: 6.5,
			rx: 1.75,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17.25,
			y: 12.75,
			width: 4,
			height: 6.5,
			rx: 1.75,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.25 19.25C19.25 20.6307 17.4591 21.75 15.25 21.75H12.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		})
	]
});
export default SvgHeadset;
